export const GRAPH_HINT_SHOW = 'GRAPH_HINT_SHOW';
export const GRAPH_HINT_HIDE = 'GRAPH_HINT_HIDE';
